import { render, staticRenderFns } from "./picture-text-header.vue?vue&type=template&id=693ba8cd&scoped=true&"
import script from "./picture-text-header.vue?vue&type=script&lang=js&"
export * from "./picture-text-header.vue?vue&type=script&lang=js&"
import style0 from "./picture-text-header.vue?vue&type=style&index=0&id=693ba8cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693ba8cd",
  null
  
)

export default component.exports